import axios from 'axios';
import resolvePath from 'utils/resolvePath';
// Action
const GET_RESERVABLE_REQUEST = 'evaluations/getReservableRequest';
const GET_RESERVABLE_SUCCESS = 'evaluations/getReservableSuccess';
const GET_RESERVABLE_FAILURE = 'evaluations/getReservableFailure';
const CLEAR_RESERVABLE = 'evaluations/clearReservable';
export const getReservableRequest = () => {
    return {
        type: GET_RESERVABLE_REQUEST,
    };
};
export const getReservableSuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: GET_RESERVABLE_SUCCESS,
    };
};
export const getReservableFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_RESERVABLE_FAILURE,
    };
};
export const getReservable = (authToken, userId) => (dispatch) => {
    dispatch(getReservableRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(`${resolvePath.api(`conversations/reservable/${userId}`)}?`, config)
        .then((response) => dispatch(getReservableSuccess(response.data)))
        .catch((error) => {
        dispatch(getReservableFailure(error));
        throw error;
    });
};
export const clearReservable = () => {
    return {
        type: CLEAR_RESERVABLE,
    };
};
const initialState = {
    data: [],
    error: null,
    isFetching: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GET_RESERVABLE_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_RESERVABLE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { data: action.payload.response.data, isFetching: false });
        }
        case GET_RESERVABLE_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case CLEAR_RESERVABLE: {
            return Object.assign(Object.assign({}, state), { data: [], isFetching: false });
        }
        default: {
            return state;
        }
    }
};
